import React from 'react';
import Button, { buttonType, buttonColor } from 'Components/Button';

export default ({
  backButtonLabel,
  backButtonAction,
  boatDetailsRequestInProcess,
  cancelButtonLabel,
  cancelButtonAction,
  disableSaveButton,
  saveButtonLabel,
  saveButtonAction,
  saveAndSubmitButtonLabel,
  saveAndSubmitAction,
}) => {
  if (boatDetailsRequestInProcess) return null;

  return (
    <section className='scene_section __actions'>
      <div className='__action_left'>
        {!!backButtonLabel && (
          <Button
            label={backButtonLabel}
            color={buttonColor.planeOrange}
            buttonClassName='_height_40 _width_120'
            onClick={backButtonAction}
          />
        )}
      </div>
      <div className='__actions_right'>
        {!!cancelButtonLabel && (
          <Button
            label={cancelButtonLabel}
            type={buttonType.secondary}
            color={buttonColor.gray}
            buttonClassName='_height_40 _width_120'
            onClick={cancelButtonAction}
          />
        )}
        {!!saveButtonLabel && (
          <Button
            label={saveButtonLabel}
            disabledWithSpinner={disableSaveButton}
            buttonClassName='_height_40 _width_120'
            onClick={saveButtonAction}
          />
        )}
        {!!saveAndSubmitButtonLabel && (
          <Button
            label={saveAndSubmitButtonLabel}
            buttonClassName='_height_40 _width_170 _margin_left_20'
            onClick={saveAndSubmitAction}
            disabledWithSpinner={disableSaveButton}
          />
        )}
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Components/ApplicationActions.jsx